module.exports = __webpack_public_path__ + "static/media/yellowtang.d5c56b59.svg";